import React from "react";
import { FiPlay } from "react-icons/fi";
import { PrimaryCta } from "../components/CtaSystem";
import "./Media.css";

const youtubeVideos = [
  {
    id: 1,
    title: "Data Bolta Hai - Overview & Insights",
    url: "https://www.youtube.com/embed/WxDGANtvlMw?si=aUFxHnVt5yeF3UE3",
  },
  {
    id: 2,
    title: "GST Reconciliation & Automation Demo",
    url: "https://www.youtube.com/embed/d2dqSBypRpQ?si=cDrw7NA-WjgdgK7j",
  },
  {
    id: 3,
    title: "Banking Data Solution & Audit Mining",
    url: "https://www.youtube.com/embed/hozMjWqN_8Q?si=WIc6ksPQzh5YTafJ",
  },
];

const Media = () => {
  return (
    <div className="media-page-container">
      {/* Featured Showcase Video */}
      <section className="media-showcase-section">
        <div className="showcase-container">
          <div className="showcase-video-wrapper">
            <video className="showcase-video" loop autoPlay muted playsInline>
              <source src="display.mp4" type="video/mp4" />
              Your browser does not support the video tag.
            </video>
           
          </div>
        </div>
      </section>

      {/* YouTube Videos Section */}
      <section className="media-videos-section">
        <div className="media-section-header">
          <h2>Our YouTube Videos</h2>
          <p>Watch our official YouTube video releases and solution demonstrations.</p>
        </div>

        <div className="videos-grid">
          {youtubeVideos.map((video) => (
            <div key={video.id} className="video-card">
              <div className="iframe-wrapper">
                <iframe
                  src={video.url}
                  title={video.title}
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  referrerPolicy="strict-origin-when-cross-origin"
                  allowFullScreen
                ></iframe>
              </div>
              <div className="video-card-footer">
                <span className="play-badge">
                  <FiPlay />
                </span>
                <span className="video-card-title">{video.title}</span>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Unified Primary CTA */}
      <PrimaryCta
        eyebrow="EXPLORE DBH SOLUTIONS"
        heading="Experience Next-Gen Financial Data Automation"
        description="Schedule a demo with our technical team to see how Data Bolta Hai can streamline your financial audits and data security."
        primaryBtnText="Talk to an Expert"
        primaryBtnLink="/contact-us"
        secondaryBtnText="Contact Us"
        secondaryBtnLink="/contact-us"
      />
    </div>
  );
};

export default Media;
